<template>
  <div class="page-current-legislation'" style="min-height: 100%;">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">Current Legislation</h1>
    <p>
      ARVC's public affairs team monitors all state and national policy issues on a daily basis in an
      effort to eliminate burdensome regulations and help drive legislative outcomes that are in your
      best interest. As a benefit to OHI members, current legislation is tracked and can be accessed
      here by logging into your OHI member account.
    </p>
    <iframe src="https://app.box.com/embed/s/02ig7tep1vzcu0vuks8ddkck9bxfi7qz?sortColumn=date&amp;view=list" width="1000" height="550" frameborder="0" allowfullscreen="" webkitallowfullscreen="" msallowfullscreen=""></iframe>
  </div>
</template>

<script>
export default {
  name: 'CurrentLegislation',
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ currLegLoadError: err });
      }
    });
  },
  methods: {
  },
};
</script>
